import styled from 'styled-components';

export const FooterContainer = styled.footer`
    text-align: center;
    padding: 2rem 0;
    color: #fff;
    background: radial-gradient(ellipse at center, #0f0f1b 0%, #000000 100%);
    font-size: 0.9rem;
    position: relative;

`;

export const LogoWrapper = styled.div`
    margin-bottom: 0.5rem;
`;

export const Logo = styled.img`
    height: 32px;
`;